import { useMemo, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useRole } from '../rbac/hooks';
import {
  consumeTaskCaseDetailsReturnState,
  getTaskCaseDetailsReturnFromSearchParams,
  getTaskCaseDetailsReturnState,
  resolveDefaultTaskCaseDetailsReturn,
  type TaskCaseDetailsReturnState,
} from '../pages/task-case/taskCaseDetailsReturnNavigation';

export function useTaskCaseDetailsReturnState(): TaskCaseDetailsReturnState {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { roleCode } = useRole();
  const [storedReturn] = useState(() => consumeTaskCaseDetailsReturnState());

  return useMemo(() => {
    return (
      getTaskCaseDetailsReturnState(location.state) ??
      getTaskCaseDetailsReturnFromSearchParams(searchParams) ??
      storedReturn ??
      resolveDefaultTaskCaseDetailsReturn(roleCode)
    );
  }, [location.state, searchParams, storedReturn, roleCode]);
}
